import { ApiBulkExport, BulkExportType } from "@nens/ldo/api-v1";

export function isValidConfig(
  exportType: BulkExportType,
  name: string,
  config: ApiBulkExport["config"]
): string[] {
  const formErrorKeys: string[] = [];

  if (name.length === 0) {
    formErrorKeys.push("name");
  }

  switch (exportType) {
    case "bulk_file":
      formErrorKeys.push(...isValidBulkFileConfig(config));
      break;
    case "composite_map":
      formErrorKeys.push(...isValidCompositeMapConfig(config));
      break;
    case "ror":
      formErrorKeys.push(...isValidRorConfig(config));
      break;
  }

  return formErrorKeys;
}

function isValidBulkFileConfig(config: ApiBulkExport["config"]): string[] {
  if (!("excel_file_name" in config) || config.excel_file_name.length === 0) {
    return ["excel_file_name"];
  } else {
    return [];
  }
}

function isValidCompositeMapConfig(config: ApiBulkExport["config"]): string[] {
  if (!("raster_types" in config) || config.raster_types.length === 0) {
    return ["raster_types"];
  } else {
    return [];
  }
}

function isValidRorConfig(config: ApiBulkExport["config"]): string[] {
  if (
    !("danger_maps" in config) ||
    !("risk_maps" in config) ||
    (config.danger_maps.length === 0 && config.risk_maps.length === 0)
  ) {
    return ["maps"];
  } else {
    return [];
  }
}
